import { Point } from './types';

export function LinearInterpolate(a: Point, b: Point, x: number): Point {
    const m = (b.y - a.y) / (b.x - a.x);
    const y = (x - b.x) * m + b.y;

    return {
        x, y
    };
}
